import { gql } from '@apollo/client'

export const USER_FRAGMENTS = gql`
  fragment UserFragments on User {
    neatUserId
    firstName
    lastName
    email
    balance
    phone
    type
    address {
      country
      postalCode
    }
    createdAt
    integrations {
      recurlyId
    }
    flags {
      name
      enabled
    }
  }
`

export const PAYMENT_METHOD_FRAGMENTS = gql`
  fragment PaymentMethodFragments on PaymentMethod {
    type
    details {
      cardType
      expMonth
      expYear
      lastFour
    }
  }
`

export const INVOICE_FRAGMENTS = gql`
  fragment InvoiceFragments on Invoice {
    status
    number
    neatUserId
    dueDate
    updatedAt
    createdAt
  }
`

export const USER_QUERY = gql`
  query user {
    user {
      ...UserFragments
    }
  }
  ${USER_FRAGMENTS}
`

export const PAYMENT_METHOD_QUERY = gql`
  query paymentMethod {
    paymentMethod {
      ...PaymentMethodFragments
    }
  }
  ${PAYMENT_METHOD_FRAGMENTS}
`

export const UPDATE_PAYMENT_METHOD = gql`
  mutation updatePaymentMethod($tokenId: String!, $address: UserAddressInput) {
    updatePaymentMethod(tokenId: $tokenId, address: $address)
  }
`

export const INVOICES_QUERY = gql`
  query invoices {
    invoices {
      ...InvoiceFragments
    }
  }
  ${INVOICE_FRAGMENTS}
`

export default {}
